import { InputContentPosition, InputHelpMessagePosition, InputState, } from '@kubit/web-ui-components/input/types';
import { FONT_WEIGHT } from '../../foundations/typography';
import { InputVariantType, TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    // WARNING - Deprecated. Only used in the InputCurrency. In InputCurrencyV2 use currencyNameContainerInner or currencyNameContainerOut instead
    currencyNameContainer: {
        border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
        padding: FOUNDATIONS.spacing_200,
        background_color: FOUNDATIONS.color_comp_forms_input_bgprefixsufix,
        marginLeftOrRightByIsOutAndPosition: FOUNDATIONS.spacing_150,
        min_width: FOUNDATIONS.size_450,
        min_height: FOUNDATIONS.size_450,
    },
    // WARNING - Deprecated. Only used in the InputCurrency. In InputCurrencyV2 use the prop currencyNameContainerPosition instead
    currencyNameContainerPosition: InputContentPosition.OUT,
    // WARNING - Only used in the InputCurrencyV2
    currencyNameContainerInner: {
        border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
        currencySeparation: FOUNDATIONS.spacing_150,
        inputPadding: FOUNDATIONS.spacing_200,
        inputIconSize: FOUNDATIONS.size_300,
    },
    // WARNING - Only used in the InputCurrencyV2
    currencyNameContainerOut: {
        border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
        min_width: FOUNDATIONS.size_450,
        min_height: FOUNDATIONS.size_450,
        currencySeparation: FOUNDATIONS.spacing_150,
        inputPadding: FOUNDATIONS.spacing_200,
        inputIconSize: FOUNDATIONS.size_300,
        padding: FOUNDATIONS.spacing_200,
        background_color: FOUNDATIONS.color_comp_forms_input_bgprefixsufix,
    },
    currencyName: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
    },
    helpMessage: {
        position: InputHelpMessagePosition.BOTTOM,
    },
    inputVariant: InputVariantType.REGULAR,
    bottomExtraStyles: {},
    topExtraStyles: {},
});
export const stateCommonStyles = (FOUNDATIONS, FONT) => ({
    [InputState.EMPTY]: {
        ...commonStyles(FOUNDATIONS, FONT),
    },
    [InputState.FILLED]: {
        ...commonStyles(FOUNDATIONS, FONT),
    },
    [InputState.ACTIVE]: {
        ...commonStyles(FOUNDATIONS, FONT),
    },
    [InputState.DISABLED_EMPTY]: {
        ...commonStyles(FOUNDATIONS, FONT),
        currencyName: {
            ...commonStyles(FOUNDATIONS, FONT).currencyName,
            color: FOUNDATIONS.color_accent_disabled_font_100,
        },
    },
    [InputState.DISABLED_FILLED]: {
        ...commonStyles(FOUNDATIONS, FONT),
        currencyName: {
            ...commonStyles(FOUNDATIONS, FONT).currencyName,
            color: FOUNDATIONS.color_accent_disabled_font_50,
        },
    },
    [InputState.DISABLED_FILLED_WITH_INFO]: {
        ...commonStyles(FOUNDATIONS, FONT),
        currencyName: {
            ...commonStyles(FOUNDATIONS, FONT).currencyName,
            color: FOUNDATIONS.color_accent_disabled_font_50,
        },
    },
    [InputState.ERROR_EMPTY]: {
        ...commonStyles(FOUNDATIONS, FONT),
    },
    [InputState.ERROR_FILLED]: {
        ...commonStyles(FOUNDATIONS, FONT),
    },
    [InputState.ERROR_ACTIVE]: {
        ...commonStyles(FOUNDATIONS, FONT),
    },
    [InputState.ERROR_FILLED_WITH_INFO]: {
        ...commonStyles(FOUNDATIONS, FONT),
    },
});
//# sourceMappingURL=commonStyles.js.map